// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__coeIb","blink":"DotDotDot_blink__5IKC3"};